import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { SmsLog } from '@/services/smsLogs/smsLogs.types';
import * as React from 'react';
import { getColumns } from './Column';

export const SMSLogsTable = ({
  data,
  isLoading = false,
  pagination,
}: {
  data: SmsLog[];
  isLoading: boolean;
  pagination: Pagination;
}) => {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const { table } = useDataTable({
    data,
    columns,
    pageCount,
    initialState: {
      sorting: [{ id: 'smsLogId', desc: true }],
    },
    meta: {
      title: t('logsManagement.smsLogs.crumb.smsLogs'),
      loading: isLoading,
      totalPage: pagination.totalItems,
    },
    getRowId: (originalRow) => String(originalRow.smsLogId),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <div>
      <DataTable table={table} className="rounded-lg">
        <DataTableToolbar defaultDatePreset="today" />
      </DataTable>
    </div>
  );
};
